import { useState, useEffect } from 'react';

const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Create a media query list based on the breakpoint
    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);

    // Set the initial value
    setIsMobile(mediaQuery.matches);

    // Define a callback function to handle screen resizing
    const handleResize = (event) => {
      setIsMobile(event.matches);
    };

    // Listen for changes (e.g., rotating a phone, resizing a browser window)
    // Using addEventListener is the modern standard over addListener
    mediaQuery.addEventListener('change', handleResize);

    // Cleanup function to remove the listener when the component unmounts
    return () => {
      mediaQuery.removeEventListener('change', handleResize);
    };
  }, [breakpoint]); // Re-run if the breakpoint changes

  return isMobile;
};

export default useIsMobile;